export default {
  name: "GrouponG",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    "fill-rule": "evenodd",
    d:
      "M30 16.1c0 3-.8 5.62-2.38 7.88a13.74 13.74 0 0 1-5.04 4.4A14.06 14.06 0 0 1 16 30 13.91 13.91 0 0 1 2 15.73a13 13 0 0 1 4.15-9.74C8.88 3.33 12.2 2 16.11 2c2.91 0 5.55.83 7.91 2.49a14.42 14.42 0 0 1 5.2 6.8H21.6c-1.66-1.74-3.52-2.62-5.6-2.62-1.95 0-3.62.7-5.03 2.08a6.74 6.74 0 0 0-2.1 4.98c0 2.11.72 3.9 2.16 5.38a6.94 6.94 0 0 0 11.12-1.4H14.4v-5.4h15.5c.07.8.11 1.4.11 1.8z",
    "clip-rule": "evenodd",
  },
}
